import './header.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCode, faSearch } from '@fortawesome/free-solid-svg-icons'
import data from '../FakeData/index.json'
import Links from './Links'
import { useState } from 'react'
import { Button, Collapse } from 'react-bootstrap'
import SeoHelmet from '../SEOHelmet/SeoHelmet'


function Header() {

    let query;

    const [open, setOpen] = useState(false);

    function submitURI(e) {
        e.preventDefault();
        window.location = `/search/${query}`;

    }

    let location = [
        "home",
        "blogs",
        "about Me",
        "contact",
    ]

    return (
        <header className='w3lheader'>
            <SeoHelmet pageName='Home' />
            <div className="container">
                <nav className="navbar navbar-expand-lg navbar-light fill px-lg-0 py-0 px-sm-3 px-0">
                    <a className="navbar-brand" href="/">
                        <span><FontAwesomeIcon icon={faCode} /></span> <span style={{ marginTop: '7px', fontSize: 'revert' }}> {data[0].name}</span></a>


                    <div>
                        <Button
                            className="navbar-toggler collapsed"
                            onClick={() => setOpen(!open)}
                            aria-controls="navbarSupportedContent"
                            aria-expanded={open}
                            style={{ height: `2em`, width: `2em` }}
                        >
                            {open ? <span className="fa icon-close fa-times" /> : <span className="fa icon-expand fa-bars" />}
                        </Button>
                        <Collapse in={open}>
                            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                <nav className="mx-auto searchItemm" style={{ paddingLeft: `7em` }}>
                                    <div className="search-bar">
                                        <form className="search" onSubmit={(e) => submitURI(e)}>
                                            <input type="search" className="search__input" onChange={(e) => { query = e.target.value }} name="search" placeholder="Discover Blogs and more" required />
                                            <FontAwesomeIcon icon={faSearch} className='search__icon' />
                                            {/* <button className="btn btn-primary" onClick={() => { handleClick() }}>Search</button> */}
                                        </form>
                                    </div>
                                </nav>
                                <ul className="navbar-nav navItemm" style={{ paddingLeft: `4em` }}>
                                    {location.map((loc, index) => {
                                        return <Links key={index} location={loc} />
                                    })}
                                </ul>
                            </div>
                        </Collapse>
                    </div>


                </nav>
            </div>
        </header >

    )
}

export default Header
